import React from 'react'
import PropTypes from 'prop-types'
import { useGoogleLogin } from "@react-oauth/google"
import { IconGoogle } from '../../Icons/IconGoogle'

function LoginGoogleButton(props) {
    const { state, onSucess, handleRemove, onError ,isModal, t} = props

    const googleLogin = useGoogleLogin({
        onSuccess: async dataResponse => {
            console.log('LoginGoogleButtonV2=>dataResponse=', dataResponse)
            // props.handleGoogleResponse(dataResponse);
            onSucess(dataResponse.access_token)
        },
        onError: (e) => {
            console.log('Login Failed: ', e);
            onError(e)
        }
    })
    return (
        !isModal ? <div className="flex flex-col justify-center items-center gap-5">
            <IconGoogle className="w-[20px]" />
            {
                !state && <button className="border border-solid border-black/[0.1] 
                rounded-[5px] bg-white h-[30px] min-w-[72px]  px-1 lg:w-[85px] 
                text-center text-black text-xs" onClick={() => googleLogin()}>
                    {t('Connect')}</button>
            }
            {
                state && <button className="border border-solid border-black/[0.1] 
                rounded-[5px] bg-white h-[30px] min-w-[72px]  px-1 lg:w-[85px] 
                text-center text-suzu-error text-xs" onClick={() => handleRemove()}>
                    {t('title.disconnect')}</button>
            }

        </div> : <div className="flex flex-row justify-start  items-center gap-[10px] lg:gap-[15px]" >
            <IconGoogle className="w-[20px]" />
            <button className="text-center text-black text-xs" onClick={() => googleLogin()}>
            <span className="text-black text-[14px]">
                  {t("title_connect_google_account")}
                </span></button>
        </div>
    )
}

LoginGoogleButton.propTypes = {
    state: PropTypes.string,
    onSucess: PropTypes.func,
    handleRemove: PropTypes.func
}

export default LoginGoogleButton

